import React, { useState } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import styles from './index.module.css'
import axiosInstance from '../../util/axios.js'
import { SUPPORT_EMAIL, API_ROUTES } from '../../util/constants.js'
import CircularProgress from '@mui/material/CircularProgress'
import styled from 'styled-components'

export default function Contact() {
	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [subject, setSubject] = useState('')
	const [message, setMessage] = useState('')
	const [receiveCopy, setReceiveCopy] = useState(false)

	const [resultMessage, setResultMessage] = useState('')
	const [sended, setSended] = useState(false)
	const [loading, setLoading] = useState(false)

	//messages
	const errorWhileSendingEmail =
		'Ein Fehler ist aufgetreten, daher konnte die Email nicht gesendet werden! \n' +
		'Melden Sie dies bitte umgehend unter folgender Email: ' +
		SUPPORT_EMAIL +
		'. \n' +
		'Einer unser Entwickler wird sich dann zügig um das Problem kümmern. \n'

	const sucSendingEmail =
		'Ihre Nachricht wurde erfolgreich gesendet. \n' +
		'Wir werden uns bald bei Ihnen melden.'

	const errorCooldown =
		'Ihre Email konnte nicht gesendet werden! \n' +
		'Warte Sie einen Moment ab und versuche es erneut.'

	const unknownError =
		'Ein unbekannter Fehler ist aufgetreten! \n' +
		'Melden Sie dies bitte umgehend unter folgender Email: ' +
		SUPPORT_EMAIL +
		'. \n'

	function onSubmit(e) {
		e.preventDefault()
		setLoading(true)
		axiosInstance({
			url: API_ROUTES.ENTITY_CREATE('contact_request'),
			data: {
				name,
				email,
				phoneNumber,
				subject,
				message,
				confirmation: receiveCopy,
			},
			method: 'POST',
			timeout: 20000, //20 seconds to avoid timeout, when smtp server has a email per minute limit
		})
			.then((result) => {
				if (result) {
					setResultMessage(sucSendingEmail)
				} else {
					setResultMessage(errorWhileSendingEmail)
				}
				setSended(true)
			})
			.catch((error) => {
				console.error(error)
				if (error.code === 'ECONNABORTED') {
					//timeout
					setResultMessage(errorWhileSendingEmail)
				} else if (error.response && error.response.status === 429) {
					//cooldown
					setResultMessage(errorCooldown)
				} else {
					setResultMessage(unknownError)
				}
				setSended(true)
			})
			.finally(() => {
				setLoading(false)
			})
	}

	return (
		<div
			id='page-container'
			className={sended ? 'homeImage' : ''}
			style={loading ? { filter: 'grayscale(60%)', pointerEvents: 'none' } : {}}
		>
			<Header />
			{sended ? (
				<div className={styles.displayText}>
					<h1>{resultMessage}</h1>
				</div>
			) : (
				<ContentWrapper>
					<IntroText>
						Wenn Sie Kontakt mit uns aufnehmen möchten, dann können Sie hier
						eine kurze Nachricht schreiben...
					</IntroText>

					<StyledForm onSubmit={onSubmit} id='sendMailForm'>
						<FieldWrapper>
							<StyledLabel htmlFor='name'>
								Name <RedStar>*</RedStar>
							</StyledLabel>
							<StyledInput
								id='name'
								type='text'
								placeholder='Name'
								value={name}
								onChange={(e) => setName(e.target.value)}
								required
							/>
						</FieldWrapper>

						<FieldWrapper>
							<StyledLabel htmlFor='email'>
								E-Mail <RedStar>*</RedStar>
							</StyledLabel>
							<StyledInput
								id='email'
								type='email'
								placeholder='E-Mail'
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
							/>
						</FieldWrapper>

						<FieldWrapper>
							<StyledLabel htmlFor='subject'>
								Betreff<RedStar> *</RedStar>
							</StyledLabel>
							<StyledInput
								id='subject'
								type='text'
								placeholder='Betreff'
								value={subject}
								onChange={(e) => setSubject(e.target.value)}
								required
							/>
						</FieldWrapper>

						<FieldWrapper>
							<StyledLabel htmlFor='phone'>
								Telefonnummer<RedStar> *</RedStar>
							</StyledLabel>
							<StyledInput
								id='phone'
								type='text'
								placeholder='Telefonnummer'
								value={phoneNumber}
								onChange={(e) => setPhoneNumber(e.target.value)}
								required
							/>
						</FieldWrapper>

						<FullWidthWrapper>
							<FieldWrapper>
								<StyledLabel htmlFor='message'>
									Nachricht<RedStar> *</RedStar>
								</StyledLabel>
								<StyledInput
									as='textarea'
									id='message'
									rows='5'
									placeholder='Schreiben Sie hier Ihre Nachricht'
									value={message}
									onChange={(e) => setMessage(e.target.value)}
									required
								/>
							</FieldWrapper>

							<RequiredFieldsHint>
								<RedStar>*</RedStar>) Pflichtangabe
							</RequiredFieldsHint>

							<CheckboxContainer>
								<input
									type='checkbox'
									id='receiveCopy'
									checked={receiveCopy}
									onChange={() => setReceiveCopy(!receiveCopy)}
								/>
								<label htmlFor='receiveCopy'>
									Kopie der Email an Sie senden?
								</label>
							</CheckboxContainer>

							<SubmitButton type='submit'>Senden</SubmitButton>
						</FullWidthWrapper>
					</StyledForm>
				</ContentWrapper>
			)}
			<Footer />
			{loading && (
				<div className={styles.loadingOverlay}>
					<CircularProgress size={64} thickness={4} />
				</div>
			)}
		</div>
	)
}

// Styled Components
const ContentWrapper = styled.div`
	max-width: 800px;
	margin: 60px auto;
	padding: 0 20px;
`

const IntroText = styled.p`
	font-size: 1.6rem;
	font-weight: bold;
	margin-bottom: 50px;

	text-align: left;
`

const StyledForm = styled.form`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;

	@media (max-width: 600px) {
		grid-template-columns: 1fr;
	}
`

const FieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`

const FullWidthWrapper = styled.div`
	grid-column: 1 / -1;
	display: flex;
	flex-direction: column;
`

const StyledLabel = styled.label`
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 8px;
	color: #000;
`

const RedStar = styled.span`
	color: #ff4d4d;
	font-size: 18px;
	font-weight: bold;
`

const StyledInput = styled.input`
	padding: 12px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	font-size: 16px;
	width: 100%;
	box-sizing: border-box;

	&:focus {
		border-color: #3b82f6;
		outline: none;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}
`

const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 20px 0 30px 0; // Viel Abstand zum Senden-Button

	label {
		font-size: 16px;
		color: #374151;
		cursor: pointer;
	}

	input {
		width: 18px;
		height: 18px;
		cursor: pointer;
	}
`

const RequiredFieldsHint = styled.p`
	margin: 20px 0 0;
	font-size: 16px;
	color: #374151;
`

const SubmitButton = styled.button`
	width: 100%;
	padding: 14px;
	background-color: #3b82f6;
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 18px;
	font-weight: bold;
	cursor: pointer;
	transition: background 0.2s ease-in-out;

	&:hover {
		background-color: #2563eb;
	}

	&:active {
		transform: scale(0.98);
	}
`
